
export function formatCurrency(number) {
    return new Intl.NumberFormat('sv-SE', 
        { style: 'currency', currency: 'SEK', maximumFractionDigits: 0 })
        .format(number);
}